
import { BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicFormsApi extends BaseModulePublicApi {
  basePath = 'forms';
};
